<!-- tabs的属性 -->
<template>
    <div style="padding-bottom: 30px;">
        <div v-if="isShowEdit2" class="w-100">
            <el-form label-width="150px">
                <el-col :span="12" v-for="(item, index) in property" :key="index">
                    <el-form-item :label=" `${ getLanguage() === 'zh_CN'? item.name : item.code}:`">
                        {{ item.value || '---' }}
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item label-width="0px">
                        <!-- 编辑按钮 -->
                        <el-button type="primary" @click="isShowEdit2 = false">
                            {{ $t('public.edit') }}
                        </el-button>
                    </el-form-item>
                </el-col>
            </el-form>
        </div>

        <div v-show="!isShowEdit2" class="w-100">
            <el-form label-width="150px" :rules="rule" :model="paramMap" ref="attribute" :validate-on-rule-change="false">
                <el-col :span="12" v-for="(item, index) in property" :key="index">
                    <el-form-item :label=" `${ getLanguage() === 'zh_CN'? item.name : item.code}:`" :prop="`${item.code}`" :required="item.isRequired ? true : false">
                        <el-input v-model="paramMap[item.code]"></el-input>
                    </el-form-item>
                </el-col>

                <el-col :span="24">
                    <el-form-item label-width="0px">
                        <el-button type="primary" @click="save" style="margin-right:15px">
                            {{ $t('public.save') }}
                        </el-button>
                        <el-button type="primary" @click="isShowEdit2 = true"> {{ $t('integration.back') }}</el-button>
                    </el-form-item>
                </el-col>
            </el-form>

            <!-- <div class="uk-flex uk-flex-center">

            </div> -->
        </div>
    </div>
</template>

<script>
import { shareParam } from '@/api/modules/public';
import { saveProperty } from '@/api/modules/carrier';
import { carrierDetail } from '@/api/modules/carrier.js';
import { getLanguage } from '@/lang';

export default {
    props: {
        detailObj: {
            type: Object,
            default: () => {
                return {};
            }
        }
    },
    data() {
        return {
            property: [],
            // 从服务器请求回来的rules
            rules: [],
            // 本地动态生成的rule 用于element 表单校验
            rule: null,
            paramMap: {},
            isShowEdit2: true,
            rawModel: {},
            getLanguage
        };
    },
    methods: {
        // 初始化属性列表
        initProperty() {
            const property = JSON.parse(this.detailObj.property || '{}');
            const propertyList = this.detailObj.carrierType.carrierTypePropertyList || [];
            const list = [];

            //拿propertyList去匹配property
            propertyList.forEach(item => {
                list.push({
                    ...item,
                    value: property ? property[item.code] : ''
                });

                // 初始化model 用于表单验证
                this.$set(this.paramMap, item.code, property ? property[item.code] : '');
            });

            // 用户点返回需要还原数据

            this.rawModel = { ...this.paramMap };

            this.property = list;
        },
        // 初始化规则
        initRules() {
            return new Promise(resolve => {
                shareParam({
                    code: 'carrier_type_rule',
                    type: 0
                }).then(({ result }) => {
                    const rule = {};
                    result.forEach(item => {
                        // 单个反斜杠会报错啊!!! 只能换成两个反斜杠了  用的时候再转回去
                        // 重写content属性
                        rule[item.code] = {
                            ...item,
                            content: JSON.parse(item.content.replace(/\\/g, '\\\\'))
                        };
                    });
                    this.rules = rule;
                    resolve();
                });
            });
        },
        // 根据请求回来的规则生成规则列表
        async genRuleList() {
            this.initProperty();
            await this.initRules();

            const rule = {};

            this.property.forEach(item => {
                const reg = eval(this.rules[item.dataRule].content.rule.replace(/\\\\/g, '\\'));
                rule[item.code] = [
                    {
                        required: item.isRequired ? true : false,
                        message: `[${item.name}]` + $t('integration.input_verification_failed'),
                        trigger: 'blur',
                        pattern: reg
                    }
                ];
            });
            this.rule = rule;
        },
        // 保存属性
        save() {
            this.$refs['attribute'].validate(valid => {
                if (valid) {
                    const detailObj = this.detailObj;
                    //console.log(this.$route.query);
                    saveProperty(detailObj.typeId, detailObj.carrierType.id, detailObj.id, this.paramMap).then(({ result }) => {
                        if (result) {
                            this.$message.success($t('integration.saved_successfully'));
                            // 更新属性界面的值
                            this.property = this.property.map(item => {
                                item.value = this.paramMap[item.code];
                                return item;
                            });
                            //this.$attrs.isShowEdit2=true;
                            // this.$emit('update:isShowEdit2', true);
                            this.isShowEdit2 = true;
                        } else {
                            this.$message.error($t('integration.operation_failed'));
                        }
                    });
                }
            });
        },
        async initDetailObj() {
            const { type, id } = this.$route.query;
            await carrierDetail(type, id).then(({ result }) => {
                if (result) {
                    //获取设备对应的图片
                    //this.detailObj = result || {}
                    Object.keys(result).forEach(item => {
                        this.$set(this.detailObj, item, result[item]);
                    });
                }
            });
        }
        // back() {
        //     // 还原值
        //     Object.keys(this.rawModel).forEach(key => {
        //         this.$set(this.paramMap, key, this.rawModel[key]);
        //     });
        //     this.isShowEdit2 = true;
        // }
    },
    async mounted() {
        // detail为空则自动获取
        if (!Object.keys(this.detailObj).length) {
            //this.$set(this.$attrs,'isShowEdit2',true)
            await this.initDetailObj();
        }
        this.genRuleList();
    }
};
</script>

<style></style>
